import { cn } from "@cloai/uikit";
import { CSSProperties } from "react";

export const STYLES = {
  portal: {
    variants: {
      medium: {
        "--spacing-popup-widht": "calc(var(--spacing) * 120)",
      } as CSSProperties,
      wide: {
        "--spacing-popup-widht": "calc(var(--spacing) * 240)",
      } as CSSProperties,
    },
  },
  wrapper: {
    base: cn(
      "group/item relative flex size-full cursor-pointer overflow-hidden rounded-xl duration-300 select-none",
      "flex items-center justify-center bg-card-border duration-300",
      "after:pointer-events-none after:absolute after:size-full after:bg-card/20",
      "hover:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.1)_c_h)]",
      "active:scale-95 active:bg-[oklch(from_var(--color-card-border)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    variants: {
      square: "aspect-square",
      wide: "aspect-[920/603]",
    },
  },
  image: cn(
    "pointer-events-none block size-full object-contain object-bottom duration-300",
    "group-hover/item:scale-103 group-hover/item:duration-800",
  ),
  text: {
    base: cn(
      "relative z-1 text-center text-2xl font-bold text-balance text-white uppercase text-shadow-md",
    ),
    variants: {
      default: "md:text-3xl",
      small: "md:text-2xl ",
    },
  },
  dropzone: {
    base: cn(
      "group/item relative flex aspect-[1/2] size-full cursor-pointer flex-col items-center justify-center gap-5 overflow-hidden rounded-xl bg-regular duration-300 select-none",
      "border-3 border-dashed border-primary p-5",
      "@lg:aspect-[2/1]",
      "after:absolute after:size-full after:bg-card/20",
      "hover:bg-[oklch(from_var(--color-regular)_calc(l_+_0.1)_c_h)]",
      "active:scale-98 active:bg-[oklch(from_var(--color-regular)_calc(l_+_0.05)_c_h)] active:duration-100",
    ),
    states: {
      draging: cn(
        "border-solid bg-[oklch(from_var(--color-regular)_calc(l_+_0.1)_c_h)]",
      ),
      loading: cn("pointer-events-none opacity-80"),
    },
  },
};

export const MOTION_VARIANTS = {
  container: {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // задержка между анимациями детей
        delayChildren: 0.2, // начальная задержка
        when: "beforeChildren", // гарантирует, что контейнер анимируется перед дочерними
      },
    },
    exit: {
      opacity: 0,
      transition: {
        when: "afterChildren", // контейнер исчезает после дочерних
      },
    },
  },

  item: {
    hidden: {
      opacity: 0,
      scale: 0.8,
    },
    visible: (index: number) => ({
      // добавляем custom для контроля задержки
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring", // Тип анимации - пружинная
        stiffness: 400, // Жесткость пружины
        damping: 10, // Затухание колебаний
        mass: 0.4, // Масса объекта
        bounce: 0.3, //Упругость отскока
        duration: 0.2, // Длительность анимации в секундах
        delay: index * 0.05, // Задержка перед началом анимации (здесь на основе индекса)
      },
    }),
  },
};
